export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/non-tampered-icon.62f2eeaa.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};